// extracted by mini-css-extract-plugin
export default {"timer":"GameTimer_timer__nNRpw"};